import { render, staticRenderFns } from "./DrawerContent.vue?vue&type=template&id=a9236534&"
import script from "./DrawerContent.vue?vue&type=script&lang=js&"
export * from "./DrawerContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports